import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

const TeamSection = () => {
  const { language } = useLanguage();
  const t = translations[language];
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <section id="team" className="py-24 bg-gradient-to-br from-cream-50 via-white to-blue-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-navy-900 mb-4">{t.team.title}</h2>
          <p className="text-xl text-gold-600 font-medium">{t.team.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.team.members.map((member) => (
            <div
              key={member.name}
              className="group bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              onClick={() => setSelectedMember(member)}
            >
              <div className="aspect-square bg-gradient-to-br from-navy-100 to-blue-100 relative overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300 p-4"
                />
              </div>
              <div className="p-4">
                <h3 className="text-lg font-bold text-navy-900 mb-1">{member.name}</h3>
                <p className="text-gold-600 font-medium text-sm mb-3">{member.position}</p>
                <Button
                  variant="outline"
                  className="w-full border-navy-700 text-navy-700 hover:bg-navy-700 hover:text-white text-sm py-2"
                >
                  {t.team.viewBio}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Dialog open={!!selectedMember} onOpenChange={() => setSelectedMember(null)}>
        <DialogContent className="max-w-3xl max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-3xl font-bold text-navy-900">
              {selectedMember?.name}
            </DialogTitle>
            <p className="text-lg text-gold-600 font-medium">{selectedMember?.position}</p>
          </DialogHeader>
          <div className="mt-6">
            <div className="mb-6">
              <img
                src={selectedMember?.image}
                alt={selectedMember?.name}
                className="w-48 h-48 object-contain rounded-lg mx-auto shadow-lg bg-gradient-to-br from-navy-100 to-blue-100 p-2"
              />
            </div>
            <div className="prose prose-lg max-w-none">
              {selectedMember?.bio.split('\n').map((paragraph, index) => (
                <p key={index} className="text-gray-700 leading-relaxed mb-4">
                  {paragraph}
                </p>
              ))}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default TeamSection;